import { render, staticRenderFns } from "./brower-open.vue?vue&type=template&id=f90375aa&scoped=true&"
import script from "./brower-open.vue?vue&type=script&lang=js&"
export * from "./brower-open.vue?vue&type=script&lang=js&"
import style0 from "./brower-open.vue?vue&type=style&index=0&id=f90375aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f90375aa",
  null
  
)

export default component.exports